import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GrupAtributeComponent } from './grup-atribute.component';
import { AddGrupAtributeComponent } from './add-grup-atribute/add-grup-atribute.component';
import { EditGrupAtributeComponent } from './edit-grup-atribute/edit-grup-atribute.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        GrupAtributeComponent,
        AddGrupAtributeComponent,
        EditGrupAtributeComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [
        GrupAtributeComponent
    ],
})
export class GrupAtributeModule { }
